<div class="grid-6 copo-container footer-margin" *ngIf="batchData">
	<div class="grid-column-one-full">
		<mat-expansion-panel [expanded]="true" class="card-info-block">
			<mat-expansion-panel-header>
				<mat-panel-title class="card-content-title">
					<span translate>aqdb.shipping</span>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-divider class="margin-expansion-panel"></mat-divider>
			<div class="card-content-block triple-column">
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.mill.description</div>
						<div class="card-content-value">{{ batchData.deliveryMillDescription ? batchData.deliveryMillDescription: UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.dispatch.advice.number</div>
						<div class="card-content-value">{{ batchData.despatchAdviceNumber ?
							batchData.despatchAdviceNumber: UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.dispatch.date</div>
						<div class="card-content-value">{{ batchData.shipmentDate | copoDate:'date' }}</div>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
</div>